<template>

    <section class="questions">

        <div class="questions-inner">

            <h2 class="heading">
                Fragen
            </h2>

            <div class="search">

                <div class="search-input">
                    <form v-on:submit.prevent="search">
                        <input
                                type="search"
                                placeholder="Wie spreche ich über ... ?"
                                v-model="searchValue"
                        >
                    </form>
                </div>

            </div>

            <tags
                    :article-primary-keyword-data="tags"
                    v-bind:class="{ 'isScrolledIntoView' : isLoaded && isReflowed && isScrolledIntoView }"
            ></tags>

        </div>

    </section>

</template>

<script>

    // console.log('Questions');

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
    import cssUnitHelper from '../services/cssUnitHelper';
    import scrollHelper from '../services/scrollHelper';
    import wpApi from '../services/wpApi';

    import Tags from './Tags.vue';

    export default {
        mixins : [smoothReflow],
        created(){
            window.addEventListener('scroll', this.scrollHandler, { passive : true });
        },
        destroyed(){
            window.removeEventListener('scroll', this.scrollHandler);
            this.$el.removeEventListener('transitionend', this.transitionEndHandler);
        },
        mounted(){
            this.$el.addEventListener('transitionend', this.transitionEndHandler);
            this.$smoothReflow({
                transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
            });
            this.scrollHandler();
        },
        components : {
            Tags,
        },
        data(){
            return {
                isLoaded : false,
                isLoading : false,
                isReflowed : false,
                isScrolledIntoView : false,
                scrollViewOffsetTopPx : cssUnitHelper.remToPx(8),
                searchValue : '',
                tags : [],
                wpApi,
            };
        },
        methods : {
            load(){
                this.$root.promises.tags.then((response)=>{
                    if (Array.isArray(response.data) === false || response.data.length === 0) {
                        return;
                    }
                    this.tags = response.data;
                    this.isLoaded = true;
                    this.isLoading = false;
                });
            },
            scrollHandler(){
                this.isScrolledIntoView = scrollHelper.isScrolledIntoView(
                    this.$el, this.scrollViewOffsetTopPx * cssMediaQueryHelper.watch.factor,
                );
                if (this.isScrolledIntoView === false) {
                    return;
                }
                if (this.isLoaded === false) {
                    if (this.isLoading === false) {
                        this.isLoading = true;
                        this.load();
                    }
                }
                window.removeEventListener('scroll', this.scrollHandler);
            },
            search(){
                console.log('search');
                this.$router.push('/suche/' + this.searchValue);
            },
            transitionEndHandler(event){
                if (this.isLoaded && event.target === this.$el) {
                    this.isReflowed = true;
                }
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .questions {
        background-color: $color-nochvielvor-white;
        overflow: hidden;
        will-change: height;
        .questions-inner {
            padding: 2.5rem 1.5rem 5.5rem 1.5rem;
            @media screen and (min-width: 1200px) {
                padding: 2.5rem * $factor-1200 1.5rem * $factor-1200 5.5rem * $factor-1200 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 2.5rem * $factor-1440 1.5rem * $factor-1440 5.5rem * $factor-1440 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 2.5rem * $factor-1920 1.5rem * $factor-1920 5.5rem * $factor-1920 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 2.5rem * $factor-2400 1.5rem * $factor-2400 5.5rem * $factor-2400 1.5rem * $factor-2400;
            }
        }
        .heading {
            margin: 0 0 3.5rem 0;
            color: $color-nochvielvor-pink;
            font-size: 2.25rem;
            font-weight: bold;
            text-transform: uppercase;
            @media screen and (min-width: 1200px) {
                margin: 0 0 3.5rem * $factor-1200 0;
                font-size: 2.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 3.5rem * $factor-1440 0;
                font-size: 2.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 3.5rem * $factor-1920 0;
                font-size: 2.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 3.5rem * $factor-2400 0;
                font-size: 2.25rem * $factor-2400;
            }
        }
        .search {
            width: calc(100% - 7.5rem - 7.5rem);
            margin: 0 auto;
            @media screen and (max-width: 767px) {
                width: 100%;
            }
            @media screen and (min-width: 1200px) {
                width: calc(100% - 7.5rem * #{$factor-1200} - 7.5rem * #{$factor-1200});
            }
            @media screen and (min-width: 1440px) {
                width: calc(100% - 7.5rem * #{$factor-1440} - 7.5rem * #{$factor-1440});
            }
            @media screen and (min-width: 1920px) {
                width: calc(100% - 7.5rem * #{$factor-1920} - 7.5rem * #{$factor-1920});
            }
            @media screen and (min-width: 2400px) {
                width: calc(100% - 7.5rem * #{$factor-2400} - 7.5rem * #{$factor-2400});
            }
            .search-input {
                position: relative;
                margin-bottom: 4rem;
                @media screen and (min-width: 1200px) {
                    margin-bottom: 4rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-bottom: 4rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-bottom: 4rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-bottom: 4rem * $factor-2400;
                }
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1.75rem;
                    height: 3.5rem - 0.3125rem;
                    background-image: url(/img/ic_search_000000.svg);
                    background-repeat: no-repeat;
                    background-position: 50% 50%;
                    background-size: 1.6875rem 1.5625rem;
                    @media screen and (max-width: 767px) {
                        //width: 1.75rem * $factor-720;
                        //height: (3.5rem - 0.3125rem) * $factor-720;
                        //background-size: 1.6875rem * $factor-720 1.5625rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        width: 1.75rem * $factor-1200;
                        height: (3.5rem - 0.3125rem) * $factor-1200;
                        background-size: 1.6875rem * $factor-1200 1.5625rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 1.75rem * $factor-1440;
                        height: (3.5rem - 0.3125rem) * $factor-1440;
                        background-size: 1.6875rem * $factor-1440 1.5625rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 1.75rem * $factor-1920;
                        height: (3.5rem - 0.3125rem) * $factor-1920;
                        background-size: 1.6875rem * $factor-1920 1.5625rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 1.75rem * $factor-2400;
                        height: (3.5rem - 0.3125rem) * $factor-2400;
                        background-size: 1.6875rem * $factor-2400 1.5625rem * $factor-2400;
                    }
                }
                input {
                    width: 100%;
                    height: 3.5rem;
                    padding: 0 0 0 3rem;
                    border: 0 none;
                    border-bottom: 0.3125rem solid $color-nochvielvor-black;
                    caret-color: $color-nochvielvor-black;
                    font-size: 1.5rem;
                    font-weight: 500;
                    @media screen and (max-width: 767px) {
                        //height: 3.5rem * $factor-720;
                        padding: 0 0 0 3rem * $factor-720;
                        font-size: 1.5rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        height: 3.5rem * $factor-1200;
                        padding: 0 0 0 3rem * $factor-1200;
                        border-bottom-width: 0.3125rem * $factor-1200;
                        font-size: 1.5rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        height: 3.5rem * $factor-1440;
                        padding: 0 0 0 3rem * $factor-1440;
                        border-bottom-width: 0.3125rem * $factor-1440;
                        font-size: 1.5rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        height: 3.5rem * $factor-1920;
                        padding: 0 0 0 3rem * $factor-1920;
                        border-bottom-width: 0.3125rem * $factor-1920;
                        font-size: 1.5rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        height: 3.5rem * $factor-2400;
                        padding: 0 0 0 3rem * $factor-2400;
                        border-bottom-width: 0.3125rem * $factor-2400;
                        font-size: 1.5rem * $factor-2400;
                    }
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
        .tags {
            width: calc(100% - 7.5rem - 7.5rem + 0.25rem + 0.25rem);
            margin: -0.25rem auto -0.25rem auto;
            @media screen and (max-width: 767px) {
                margin: -0.25rem;
                width: calc(100% + 0.25rem + 0.25rem);
            }
            @media screen and (min-width: 1200px) {
                width: calc(100% - 7.5rem * #{$factor-1200} - 7.5rem * #{$factor-1200} + 0.25rem * #{$factor-1200} + 0.25rem * #{$factor-1200});
                margin: -0.25rem * $factor-1200 auto -0.25rem * $factor-1200 auto;
            }
            @media screen and (min-width: 1440px) {
                width: calc(100% - 7.5rem * #{$factor-1440} - 7.5rem * #{$factor-1440} + 0.25rem * #{$factor-1440} + 0.25rem * #{$factor-1440});
                margin: -0.25rem * $factor-1440 auto -0.25rem * $factor-1440 auto;
            }
            @media screen and (min-width: 1920px) {
                width: calc(100% - 7.5rem * #{$factor-1920} - 7.5rem * #{$factor-1920} + 0.25rem * #{$factor-1920} + 0.25rem * #{$factor-1920});
                margin: -0.25rem * $factor-1920 auto -0.25rem * $factor-1920 auto;
            }
            @media screen and (min-width: 2400px) {
                width: calc(100% - 7.5rem * #{$factor-2400} - 7.5rem * #{$factor-2400} + 0.25rem * #{$factor-2400} + 0.25rem * #{$factor-2400});
                margin: -0.25rem * $factor-2400 auto -0.25rem * $factor-2400 auto;
            }
            &.isScrolledIntoView {
                .tag {
                    opacity: 1;
                    transition: opacity 200ms;
                    @for $i from 1 through 40 {
                        &:nth-child(#{$i}) {
                            transition-delay: #{$i * 100}ms;
                        }
                    }
                }
            }
            .tag {
                opacity: 0;
                transition: opacity 0ms 0ms;
                will-change: opacity;
            }
        }
    }

</style>
